function fallback(current, condition, mapped) {
  if (condition === true) {
    return mapped;
  } else {
    return current;
  }
}
export {
  fallback
};
//# sourceMappingURL=fallback.js.map
